import styled from 'styled-components';
import {
  blue, tekoMedium, darkerGrey, openSans, fontSizes,
} from '../../../utils/theme';
import { Button } from '../../../utils/atoms';
import { tablet } from '../../../utils/breakpoints';

export const LeftAlignedPromoInner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 120px 70px;
  @media (max-width: ${tablet.max}px) {
    padding: 0;
  }
`;

export const LeftAlignedPromoWrapper = styled.div`
  background-image: url(${({ backgroundImage }) => backgroundImage});
  background-position: right;
  background-size: cover;
  background-repeat: no-repeat;

  &.xfl-left-aligned-promo--small {
    > div {
      padding: 120px 30px 60px 30px;

      .xfl-left-aligned-promo__content {
        padding: 0;
      }
    } 
  }

  &.xfl-left-aligned-promo--swap {
    .xfl-left-aligned-promo {
    
      &__content {
        padding-right: 0;

      }
      &__image {
        padding-right: 60px;
      }
    }
  }

  .xfl-left-aligned-promo {
    
    &__content {
      display: flex;
      flex-basis: 50%;
      flex-direction: column;
      align-items: flex-start;
      padding-right: 30px;
      
      > p, div, h1, h2, h3, h4 {
        width: 100%;
      }
      

      h4 {
        color: ${blue};
        ${tekoMedium}
        font-size: ${fontSizes.headline}px;
        text-align: left;
      }


      a {
        text-transform: uppercase;
      }

      p {
        ${openSans};
        color: ${darkerGrey};
        letter-spacing: 1.4px;
        text-align: left;
        margin-bottom: 20px;
        width: 100%;
      }

      .subtitle{
        ${tekoMedium}
        font-size: 30px;
        color: ${darkerGrey};
      }
    }

    &__image {
      flex-basis: 50%;
      padding: 40px;
      max-width: 50%;
    }

     &__description {
      margin: 25px 0;
     }
     
     &__mobile-image {
       display: none;
     }
  }

  @media (max-width: ${tablet.max}px) {
    background: white;
    padding: 57px 30px;
    align-items: center;
    justify-content: center;

    .xfl-left-aligned-promo {
      &__mobile-image {
        display: block;
        margin-bottom: 20px;
      }
      &__image {
        display: none;
      }
      &__content {
        align-items: center;
        justify-content: center;
        flex-basis: 100%;
        padding: 0;

        h4, .subtitle {
          text-align: center;
          font-size: 36px;
        }

        p {
          text-align: left;
          width: 100%;
        }
      }
    }

    &.xfl-left-aligned-promo--small {
      padding: 0;
      > div {
        padding: 60px 30px;
      } 
    }

  }
`;

export const ModalButton = styled(Button)`
  background: #fff;
`;



// WEBPACK FOOTER //
// ./src/components/left-aligned-promo/styles/leftAlignedPromo.style.js